// extracted by mini-css-extract-plugin
export default {"external":"aGvZwZ","iconWrapper":"bGvZwZ"};